import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeFromWishlist, clearWishlist, loadUserWishlist, addToWishlist } from "../../redux/slices/wishlistSlice";
import { addToCart } from "../../redux/slices/cartSlice";
import toast from "react-hot-toast";
import { clearUserWishlist, getAllWishlist, getUserWishlist, removeProductFromUserWishlist } from "../../services/WishlistService";
import { addProductToUserCart } from "../../services/cartService";


const WishlistComp = () => {

  const [wishlistData, setWishlistData] = useState([]);
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.userId);
  const wishlist = useSelector((state) => (state.wishlist.wishlistItems));
  console.log("wishlist", wishlist)
  useEffect(() => {
    if (userId) {
      const fetchWishlist = async () => {
        try {
          const wishlistData = await getAllWishlist(userId);
          dispatch(addToWishlist({ item: wishlistData, isGuest: false }));
          setWishlistData(wishlistData);
        } catch (error) {
          console.error("Failed to load wishlist:", error);
        }
      };
      fetchWishlist();
    }
  }, []);

  const handleAddToCart = async (product) => {
    if (!userId) {
      dispatch(addToCart({ item: product, isGuest: true }));
      toast.success(`${product.shortName} added to cart!`)
      return;
    };
    try {
      const cartData = {
        id: product.id,
        guid: product.guid || "",
        version: 0,
        isDeleted: false,
        createdUser: userId,
        createdDate: new Date().toISOString(),
        updatedUser: userId,
        updatedDate: new Date().toISOString(),
        prodGuId: product.prodGuId,
        quantity: 1,
        shortName: product.shortName
          || "Unnamed Product",
        retailRate: product.retailRate ?? 0,
      };

      await addProductToUserCart(cartData);
      dispatch(addToCart({ item: product, isGuest: false }));
      toast.success(`${product.shortName} added to cart!`);
    } catch (error) {
      toast.error("Failed to add to cart.");
    }
  };



  const handleRemoveFromWishlist = async (ProdGuId, product) => {
    if (!product) {
      console.error("Error: Product is undefined!");
      toast.error("Product not found!");
      return;
    }
    if (!userId) {
      dispatch(removeFromWishlist({ productId: ProdGuId, isGuest: true }));
      setWishlistData((prevWishlist) => prevWishlist.filter((item) => item.prodGuId !== ProdGuId));

      toast.success(`${product.shortName} removed from wishlist!`);
      return;
    };
    try {

      const wishlistData = {
        id: product.id,
        guid: product.guid || "",
        version: 0,
        isDeleted: true,
        createdUser: userId,
        createdDate: new Date().toISOString(),
        updatedUser: userId,
        updatedDate: new Date().toISOString(),
        prodGuId: product.prodGuId,
        shortName: product.shortName || "Unnamed Product",
        retailRate: product.retailRate ?? 0,
      };
      await removeProductFromUserWishlist(wishlistData);
      setWishlistData((prevWishlist) => prevWishlist.filter(item => item.guid !== ProdGuId));
      console.log("wishlistitems", wishlistData)
      toast.success(`${product.shortName} removed from wishlist!`);
      dispatch(removeFromWishlist({ ProdGuId, isGuest: false }));



    } catch (error) {
      toast.error("Failed to remove item from wishlist.");
      console.error("Wishlist removal error:", error);
    }
  };

  const handleClearWishlist = async () => {
    if (!userId) {
      dispatch(clearWishlist({ isGuest: true }));
      toast.success("Cart cleared successfully!");
    }
    else {
      try {
        const wishlistData = {
          createdUser: userId
        };
        await clearUserWishlist(wishlistData);
        toast.success("Wishlist cleared successfully!");
        dispatch(clearWishlist({ isGuest: false }));
        setWishlistData([]);
      } catch (error) {
        toast.error("Failed to clear wishlist.");
        console.error("Error clearing wishlist:", error);
      }
    };
  }
  const allWishItems = [...wishlistData, ...wishlist];

  console.log("allwishlistitems", allWishItems)
  return (
    <section className="ftco-menu ftco-cart">
      <div className="container">
        {allWishItems.length > 0 ? (
          <>
            <div>
              <p className="text-white"> Total Items : {allWishItems.length}</p>
              <a className="btn btn-primary btn-outline-primary rounded-0 mb-3 pb-2" onClick={() => handleClearWishlist()}>
                Clear Wishlist
              </a>
            </div>
            <div className="row">
              {allWishItems.map((item) => (
                <div className="col-md-3" key={item.guid}>
                  <div className="menu-entry">
                  <img
    src={`https://inventory-api.exodusvacations.in/${item.thumbImage.trim().replace(/^wwwroot\//,'')}`}
    alt={item.name} width={250} height={200}  className="img-fluid"/>
                             
                   
                    <div className="text text-center pt-4">
                      <h3>
                        <a href="#" className="text-decoration-none">{item.name}</a>
                      </h3>
                      <p className="p-color fw-400">₹ {item?.retailRate}</p>

                      <p>
                        <a
                          className="btn btn-primary btn-outline-primary rounded-0 mb-2"
                        
                          onClick={() => handleRemoveFromWishlist(item?.guid, item)}
                        >
                          Remove
                        </a>
                        <a onClick={() => handleAddToCart(item)} className="btn btn-primary btn-outline-primary rounded-0 mb-2">
                          Add to Cart
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="text-center py-5">
            <h3 className="text-white">Your Wishlist is Empty</h3>
            <p className="text-light">Add items to your wishlist to see them here.</p>
          </div>
        )}


      </div>
    </section>
  )
}
export default WishlistComp;